import React, { useEffect, useState } from 'react';
import {
  Paper,
  Table as MaterialTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatValueInBrazilianCurrency } from 'utils';

function Table({ data, exportPdf }) {
  const [styleEnableOverFlow, setStyleEnableOverFlow] = useState({});

  useEffect(() => {
    if (exportPdf) {
      setStyleEnableOverFlow({
        overflowY: 'hidden',
        maxHeight: 'none !important',
      });
      return;
    }
    setStyleEnableOverFlow({});
  }, [exportPdf]);
  return (
    <TableContainer
      sx={{ maxHeight: 400, ...styleEnableOverFlow }}
      component={Paper}
    >
      <MaterialTable sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: '#D2F8E2' }}>
            <TableCell>Mês - Ano</TableCell>
            <TableCell align="left">Descrição de itens</TableCell>
            <TableCell align="left">Quantidade</TableCell>
            <TableCell align="left">Custo</TableCell>
            <TableCell align="left">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            Object.entries(data.months_and_year).map(
              ([groupName, groupRows]) => {
                const { listSuply, total } = groupRows;
                return (
                  <>
                    <TableRow>
                      <TableCell rowSpan={listSuply.length + 1} align="center">
                        {groupName}
                      </TableCell>
                    </TableRow>
                    {listSuply.map((row) => (
                      <TableRow key={row.idSuply}>
                        <TableCell align="left">{row.name}</TableCell>
                        <TableCell align="left">{row.quantity}</TableCell>
                        <TableCell align="left">
                          {formatValueInBrazilianCurrency(row.cost || 0)}
                        </TableCell>
                        <TableCell align="left">
                          {formatValueInBrazilianCurrency(row.total)}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell colSpan={3} />
                      <TableCell align="left">
                        <Typography fontWeight="bold">Total</Typography>
                      </TableCell>
                      <TableCell align="left">
                        {formatValueInBrazilianCurrency(total)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={5} />
                    </TableRow>
                  </>
                );
              }
            )}
        </TableBody>
      </MaterialTable>
    </TableContainer>
  );
}

export default Table;
